import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import SalesOrderSearchFormLayout from '../salesOrdersTab/SalesOrderSearchFormLayout';
import {
    GetLookupData, GetSalesOrderGridData
} from "../../../../services/SalesOrderService";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import { OM } from "../../../../../const/constants";
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const HistoricalOrderTab = (props) => {
    const getProfileUrl = "om/SaleOrder/GetProfiles";
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ShippingDateFrom: '',
        ShippingDateTo: '',
        OrderDateFrom: '',
        OrderDateTo: '',
        R_PROFILE: '',
        R_CUSTOMER: '',
        TRANSACTIONNUMBER: '',
        PURCHASEORDERNUMBER: '',
        Module: OM,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = () => {
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {
        console.log(name, value)

    }, []);
    const handleReset = () => {
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_PROFILE", getProfileUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);

    return (
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (<Toolbar className="accordian-toolbar">
                    <Item location="before">
                        <div className="title">
                            <h6
                                style={{
                                    color: window._env_.Color2
                                }}
                            >
                                Sales Order Management - (Historical Orders)
                            </h6>
                        </div>
                    </Item>

                    <Item location="after">
                        <Button className="accordianButton" useSubmitBehavior={true} onClick={handleFormSubmit} text="Search" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div >
                        <FormField
                            currrentUser={currentUser}
                            layoutId='2BC2B56F-5C07-4CD7-A3BB-D4EC47E88E33'
                            layoutName='MyTestForm'
                            defaultFormSchema={SalesOrderSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistoricalOrderTab);